/** Identity-based navigation: never select by chemical name, SMILES or row number. */
export const positiveId = (value: unknown): number | null => {
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  if (typeof value === 'string' && !/^[1-9]\d*$/.test(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export function moleculeWorkbenchLink(fileId: unknown, moleculeId: unknown): string | null {
  const file = positiveId(fileId), molecule = positiveId(moleculeId);
  return file && molecule ? `/chemistry/file/${file}/editor?moleculeId=${molecule}` : null;
}

export function requestedMoleculeId(search: string, state: unknown): number | null {
  const params = new URLSearchParams(search);
  if (params.has('moleculeId')) return positiveId(params.get('moleculeId'));
  return positiveId((state as { moleculeId?: unknown } | null)?.moleculeId);
}

export interface WorkbenchFocus {
  moleculeId: number;
  rowIndex: number | null;
  requestKey: string;
}

// Minimal interface makes delayed server-side loading testable without AG Grid.
export function revealMolecule(api: any, focus: WorkbenchFocus): boolean {
  if (api.isDestroyed?.()) return false;
  const node = api.getRowNode(String(focus.moleculeId));
  if (node?.data && Number(node.data.id) === focus.moleculeId && node.rowIndex != null && node.rowIndex >= 0) {
    api.deselectAll();
    node.setSelected(true);
    api.ensureIndexVisible(node.rowIndex, 'middle');
    api.redrawRows({ rowNodes: [node] });
    return true;
  }
  if (focus.rowIndex != null && focus.rowIndex >= 0 && api.getDisplayedRowCount() > focus.rowIndex) {
    // Loads the correct block; onModelUpdated retries once the actual ID arrives.
    api.ensureIndexVisible(focus.rowIndex, 'middle');
  }
  return false;
}
